export enum MessageBoxActions {
  Abort = 'Abort',
  Cancel = 'Cancel',
  Close = 'Close',
  Delete = 'Delete',
  Ignore = 'Ignore',
  No = 'No',
  OK = 'OK',
  Retry = 'Retry',
  Yes = 'Yes'
}
